import enableGooglePushEvents from '@upstream/cobot_google_events';

document.addEventListener('DOMContentLoaded', () => {
  if (window.dataLayer) {
    enableGooglePushEvents(window.dataLayer);
  }
});
